import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as anioAcademicoService from '../../services/anioAcademico/anioAcademicoService';
import {
  classifyAnioAcademicoError,
  toUpdateAnioAcademicoPayload,
} from '../../services/anioAcademico/anioAcademicoDto';

export class UpdateAnioAcademico extends Component {
  static displayName = UpdateAnioAcademico.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingData: true,
      descripcion: '',
      showErrorMessage: false,
      success: false,
      id: this.props.match.params.id,
      errorMessage: '',
      details: this.props.match.params.details,
    };
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWAnioAcademico');
    if (canAccess) {
      await this.populateData();
    }
  }

  handleConfirmButton = () => {
    if (this.state.descripcion.trim().length > 0) {
      this.saveStudent();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: 'El campo descripción es obligatorio',
    });
  };

  handleDescripcionChangeInput = (e) => {
    this.setState({
      descripcion: e.target.value,
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  render() {
    if (this.state.success) {
      return <Redirect to="/md-anios" />;
    }

    const isDetail = this.state.details !== '0';
    const title = isDetail ? 'Detalle de Año Académico' : 'Modificar Año Académico';
    const { loading, loadingData } = this.state;
    const isBusy = loading || loadingData;

    return (
      <div className="md-page md-update-anio">
        <Link className="md-page__back-link" to="/md-anios">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">{title}</h1>
        </div>
        <p className="md-page__subtitle">
          {isDetail
            ? 'Consulte el año académico registrado.'
            : 'Actualice el año académico y confirme para guardar los cambios.'}
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {this.state.errorMessage && !this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loadingData ? (
            <div className="md-page__status">Cargando datos...</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están actualizando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="anio-update-descripcion">
              Año académico
            </label>
            {isDetail ? (
              <div className="md-page__field-readonly">{this.state.descripcion || '\u00a0'}</div>
            ) : (
              <input
                id="anio-update-descripcion"
                className="md-page__field-input"
                type="text"
                placeholder="Ingrese año"
                value={this.state.descripcion}
                onChange={this.handleDescripcionChangeInput}
                disabled={isBusy}
              />
            )}
          </div>

          {!isDetail ? (
            <div className="md-page__form-actions">
              <button
                type="button"
                className="md-page__form-btn md-page__form-btn--primary"
                onClick={this.handleConfirmButton}
                disabled={isBusy}
              >
                Guardar cambios
              </button>
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  async populateData() {
    this.setState({ loadingData: true });
    try {
      const model = await anioAcademicoService.getAnioAcademico(this.state.id);
      this.setState({
        loadingData: false,
        descripcion: model.anioAcademicoDescripcion,
        errorMessage: '',
        showErrorMessage: false,
      });
    } catch (error) {
      const outcome = classifyAnioAcademicoError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loadingData: false,
        errorMessage: outcome.message,
      });
    }
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await anioAcademicoService.updateAnioAcademico(
        toUpdateAnioAcademicoPayload({
          id: this.state.id,
          descripcion: this.state.descripcion,
        })
      );
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyAnioAcademicoError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loading: false,
        success: false,
        showErrorMessage: true,
        errorMessage: outcome.message,
      });
    }
  }
}
